// src/utils/taxEngine.ts
// Extracted from original TaxCalculator logic to centralize Global FBR Calculations across Make Me Filer

// Tax Slabs Interfaces
export interface TaxSlab {
  min: number;
  max: number;
  rate: number; // Percentage
  fixedTax: number;
}

export interface YearSlabs {
  [year: string]: TaxSlab[];
}

export interface TaxClassSlabs {
  salaried: YearSlabs;
  business: YearSlabs;
}

// Full 2015-2026 Dictionary (Copied verbatim from verified logic)
export const taxSlabs: TaxClassSlabs = {
  salaried: {
    "2026": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600000, max: 1200000, rate: 1, fixedTax: 0 },
      { min: 1200000, max: 2200000, rate: 11, fixedTax: 6000 },
      { min: 2200000, max: 3200000, rate: 23, fixedTax: 116000 },
      { min: 3200000, max: 4100000, rate: 30, fixedTax: 346000 },
      { min: 4100000, max: Infinity, rate: 35, fixedTax: 616000 }
    ],
    "2025": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600000, max: 1200000, rate: 5, fixedTax: 0 },
      { min: 1200000, max: 2200000, rate: 15, fixedTax: 30000 },
      { min: 2200000, max: 3200000, rate: 25, fixedTax: 180000 },
      { min: 3200000, max: 4100000, rate: 30, fixedTax: 430000 },
      { min: 4100000, max: Infinity, rate: 35, fixedTax: 700000 }
    ],
    "2024": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 2.5, fixedTax: 0 },
      { min: 1200001, max: 2400000, rate: 12.5, fixedTax: 15000 },
      { min: 2400001, max: 3600000, rate: 22.5, fixedTax: 165000 },
      { min: 3600001, max: 6000000, rate: 27.5, fixedTax: 435000 },
      { min: 6000001, max: Infinity, rate: 35, fixedTax: 1095000 }
    ],
    "2023": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 2.5, fixedTax: 0 },
      { min: 1200001, max: 2400000, rate: 12.5, fixedTax: 15000 },
      { min: 2400001, max: 3600000, rate: 20, fixedTax: 165000 },
      { min: 3600001, max: 6000000, rate: 25, fixedTax: 405000 },
      { min: 6000001, max: 12000000, rate: 32.5, fixedTax: 1005000 },
      { min: 12000001, max: Infinity, rate: 35, fixedTax: 2955000 }
    ],
    "2022": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 5, fixedTax: 0 },
      { min: 1200001, max: 1800000, rate: 10, fixedTax: 30000 },
      { min: 1800001, max: 2500000, rate: 15, fixedTax: 90000 },
      { min: 2500001, max: 3500000, rate: 17.5, fixedTax: 195000 },
      { min: 3500001, max: 5000000, rate: 20, fixedTax: 370000 },
      { min: 5000001, max: 8000000, rate: 22.5, fixedTax: 670000 },
      { min: 8000001, max: 12000000, rate: 25, fixedTax: 1345000 },
      { min: 12000001, max: 30000000, rate: 27.5, fixedTax: 2345000 },
      { min: 30000001, max: 50000000, rate: 30, fixedTax: 7295000 },
      { min: 50000001, max: 75000000, rate: 32.5, fixedTax: 13295000 },
      { min: 75000001, max: Infinity, rate: 35, fixedTax: 21420000 }
    ],
    "2021": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 5, fixedTax: 0 },
      { min: 1200001, max: 1800000, rate: 10, fixedTax: 30000 },
      { min: 1800001, max: 2500000, rate: 15, fixedTax: 90000 },
      { min: 2500001, max: 3500000, rate: 17.5, fixedTax: 195000 },
      { min: 3500001, max: 5000000, rate: 20, fixedTax: 370000 },
      { min: 5000001, max: 8000000, rate: 22.5, fixedTax: 670000 },
      { min: 8000001, max: 12000000, rate: 25, fixedTax: 1345000 },
      { min: 12000001, max: 30000000, rate: 27.5, fixedTax: 2345000 },
      { min: 30000001, max: 50000000, rate: 30, fixedTax: 7295000 },
      { min: 50000001, max: 75000000, rate: 32.5, fixedTax: 13295000 },
      { min: 75000001, max: Infinity, rate: 35, fixedTax: 21420000 }
    ],
    "2020": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 5, fixedTax: 0 },
      { min: 1200001, max: 1800000, rate: 10, fixedTax: 30000 },
      { min: 1800001, max: 2500000, rate: 15, fixedTax: 90000 },
      { min: 2500001, max: 3500000, rate: 17.5, fixedTax: 195000 },
      { min: 3500001, max: 5000000, rate: 20, fixedTax: 370000 },
      { min: 5000001, max: 8000000, rate: 22.5, fixedTax: 670000 },
      { min: 8000001, max: 12000000, rate: 25, fixedTax: 1345000 },
      { min: 12000001, max: 30000000, rate: 27.5, fixedTax: 2345000 },
      { min: 30000001, max: 50000000, rate: 30, fixedTax: 7295000 },
      { min: 50000001, max: 75000000, rate: 32.5, fixedTax: 13295000 },
      { min: 75000001, max: Infinity, rate: 35, fixedTax: 21420000 }
    ],
    "2019": [
      { min: 0, max: 400000, rate: 0, fixedTax: 0 },
      { min: 400001, max: 800000, rate: 0, fixedTax: 1000 },
      { min: 800001, max: 1200000, rate: 0, fixedTax: 2000 },
      { min: 1200001, max: 2500000, rate: 5, fixedTax: 2000 },
      { min: 2500001, max: 4000000, rate: 15, fixedTax: 65000 },
      { min: 4000001, max: 8000000, rate: 20, fixedTax: 290000 },
      { min: 8000001, max: Infinity, rate: 25, fixedTax: 1090000 }
    ]
  },
  business: {
    "2026": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 15, fixedTax: 0 },
      { min: 1200001, max: 2200000, rate: 25, fixedTax: 90000 },
      { min: 2200001, max: 3200000, rate: 30, fixedTax: 340000 },
      { min: 3200001, max: 4500000, rate: 35, fixedTax: 640000 },
      { min: 4500001, max: 6000000, rate: 40, fixedTax: 1095000 },
      { min: 6000001, max: Infinity, rate: 45, fixedTax: 1695000 },
    ],
    "2025": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 800000, rate: 12.5, fixedTax: 0 },
      { min: 800001, max: 1200000, rate: 20, fixedTax: 25000 },
      { min: 1200001, max: 2400000, rate: 25, fixedTax: 105000 },
      { min: 2400001, max: 3000000, rate: 30, fixedTax: 405000 },
      { min: 3000001, max: 4000000, rate: 32.5, fixedTax: 585000 },
      { min: 4000001, max: Infinity, rate: 35, fixedTax: 910000 },
    ],
    "2024": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 800000, rate: 12.5, fixedTax: 0 },
      { min: 800001, max: 1200000, rate: 20, fixedTax: 25000 },
      { min: 1200001, max: 2400000, rate: 25, fixedTax: 105000 },
      { min: 2400001, max: 3000000, rate: 30, fixedTax: 405000 },
      { min: 3000001, max: 4000000, rate: 32.5, fixedTax: 585000 },
      { min: 4000001, max: Infinity, rate: 35, fixedTax: 910000 },
    ],
    "2023": [
      { min: 0, max: 600000, rate: 0, fixedTax: 0 },
      { min: 600001, max: 800000, rate: 12.5, fixedTax: 0 },
      { min: 800001, max: 1200000, rate: 20, fixedTax: 25000 },
      { min: 1200001, max: 2400000, rate: 25, fixedTax: 105000 },
      { min: 2400001, max: 3000000, rate: 30, fixedTax: 405000 },
      { min: 3000001, max: 4000000, rate: 32.5, fixedTax: 585000 },
      { min: 4000001, max: Infinity, rate: 35, fixedTax: 910000 },
    ],
    "2022": [
      { min: 0, max: 400000, rate: 0, fixedTax: 0 },
      { min: 400001, max: 600000, rate: 5, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 10, fixedTax: 10000 },
      { min: 1200001, max: 2500000, rate: 15, fixedTax: 70000 },
      { min: 2500001, max: 4000000, rate: 20, fixedTax: 265000 },
      { min: 4000001, max: 6000000, rate: 25, fixedTax: 565000 },
      { min: 6000001, max: 30000000, rate: 30, fixedTax: 1065000 },
      { min: 30000001, max: Infinity, rate: 35, fixedTax: 8265000 },
    ],
    "2021": [
      { min: 0, max: 400000, rate: 0, fixedTax: 0 },
      { min: 400001, max: 600000, rate: 5, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 10, fixedTax: 10000 },
      { min: 1200001, max: 2500000, rate: 15, fixedTax: 70000 },
      { min: 2500001, max: 4000000, rate: 20, fixedTax: 265000 },
      { min: 4000001, max: 6000000, rate: 25, fixedTax: 565000 },
      { min: 6000001, max: 30000000, rate: 30, fixedTax: 1065000 },
      { min: 30000001, max: Infinity, rate: 35, fixedTax: 8265000 },
    ],
    "2020": [
      { min: 0, max: 400000, rate: 0, fixedTax: 0 },
      { min: 400001, max: 600000, rate: 5, fixedTax: 0 },
      { min: 600001, max: 1200000, rate: 10, fixedTax: 10000 },
      { min: 1200001, max: 2500000, rate: 15, fixedTax: 70000 },
      { min: 2500001, max: 4000000, rate: 20, fixedTax: 265000 },
      { min: 4000001, max: 6000000, rate: 25, fixedTax: 565000 },
      { min: 6000001, max: 30000000, rate: 30, fixedTax: 1065000 },
      { min: 30000001, max: Infinity, rate: 35, fixedTax: 8265000 },
    ],
    "2019": [
      { min: 0, max: 400000, rate: 0, fixedTax: 0 },
      { min: 400001, max: 800000, rate: 0, fixedTax: 1000 },
      { min: 800001, max: 1200000, rate: 0, fixedTax: 2000 },
      { min: 1200001, max: 2400000, rate: 15, fixedTax: 15000 },
      { min: 2400001, max: 4800000, rate: 20, fixedTax: 195000 },
      { min: 4800001, max: Infinity, rate: 29, fixedTax: 675000 },
    ],
  }
};

/**
 * Executes a full live tax calculation according to PK standard active FBR rules.
 * 
 * Rules:
 * - If salary is >= 75% of Taxable Income, apply `salaried` slabs.
 * - Otherwise, apply `business` (Non-Salaried) slabs.
 * - Exempt incomes (Pension, Agriculture) do NOT apply to Taxable Income, but exist in Total Inflow.
 */
export const calculateLiveTax = (
  totalTaxableIncome: number,
  salaryIncome: number,
  selectedYear: string
) => {
  if (totalTaxableIncome <= 0 || !selectedYear) return { taxAmount: 0, classApplied: 'business', slabUsed: null };

  // Safety fallback for unsupported years
  const targetYear = taxSlabs.salaried[selectedYear] ? selectedYear : "2024";

  // Salary >= 75% rules
  const salRatio = totalTaxableIncome > 0 ? (salaryIncome / totalTaxableIncome) : 0;
  const applicableClass = salRatio >= 0.75 ? "salaried" : "business";
  
  const applicableSlabs = taxSlabs[applicableClass as keyof TaxClassSlabs][targetYear];

  let taxAmount = 0;
  let slabUsed: TaxSlab | null = null;
  
  if (applicableSlabs) {
    const matchedSlab = applicableSlabs.find(
      slab => totalTaxableIncome >= slab.min && totalTaxableIncome <= slab.max
    );

    if (matchedSlab) {
        taxAmount = matchedSlab.fixedTax + ((totalTaxableIncome - matchedSlab.min) * (matchedSlab.rate / 100));
        slabUsed = matchedSlab;
    }
  }

  return { taxAmount, classApplied: applicableClass, slabUsed };
};

/**
 * Calculates current default active tax year based on the strict financial boundary (July 1 - June 30)
 */
export const computeDefaultTaxYear = (): string => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth(); // 0 is January
  
  // Tax year ends on June 30th. 
  // If we are before July (months 0-5), the current tax year hasn't ended yet, so default to previous year.
  // If we are in or after July (months 6-11), the tax year for the current calendar year has ended.
  if (month < 6) {
     return (year - 1).toString();
  }
  return year.toString();
};
